export default "__VITE_ASSET__Bkd_ZF21__"